export const questionnaireEvaluationQuestionGetSuccessReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { questionList: [action.payload], isSaveSuccess: false });
};
//# sourceMappingURL=questionnaireEvaluationQuestionGetSuccessReducer.js.map